import { registerComponent } from '@gig/magic-common';
import LoyaltyProgressComponent from './loyalty-progress.vue.js';

var LoyaltyProgress = registerComponent(LoyaltyProgressComponent);

export { LoyaltyProgress };
